import * as React from 'react';
import Title from './Title';
import SearchContainer from './SearchContainer';

const Home = () => (
  <>
    <Title />
    <SearchContainer />
  </>
);

export default Home;
